// extracted by mini-css-extract-plugin
export var errorIcon = "_j7-1";
export var nameLogo = "_j7-0";